import { render, staticRenderFns } from "./RatingsViewerSkipped.vue?vue&type=template&id=37f6f2ca"
import script from "./RatingsViewerSkipped.vue?vue&type=script&lang=ts"
export * from "./RatingsViewerSkipped.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports